var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestementModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2584_12595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2584_12595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54995 17.8251L1.32495 16.9251L6.02495 9.4251L9.02495 12.9251L13 6.4501L15.4 10.0501C15.1166 10.0668 14.846 10.1041 14.588 10.1621C14.3293 10.2208 14.075 10.3001 13.825 10.4001L13.075 9.2501L9.24995 15.4501L6.22495 11.9251L2.54995 17.8251ZM21.575 22.6501L18.2999 19.3751C17.9833 19.6084 17.6333 19.7834 17.25 19.9001C16.8666 20.0168 16.475 20.0751 16.075 20.0751C14.9583 20.0751 14.0126 19.6878 13.238 18.9131C12.4626 18.1378 12.075 17.1918 12.075 16.0751C12.075 14.9584 12.4626 14.0124 13.238 13.2371C14.0126 12.4624 14.9583 12.0751 16.075 12.0751C17.1916 12.0751 18.1376 12.4624 18.913 13.2371C19.6876 14.0124 20.075 14.9584 20.075 16.0751C20.075 16.4918 20.0166 16.8918 19.9 17.2751C19.7833 17.6584 19.6083 18.0084 19.375 18.3251L22.65 21.5751L21.575 22.6501ZM16.075 18.5751C16.775 18.5751 17.3666 18.3334 17.85 17.8501C18.3333 17.3668 18.575 16.7751 18.575 16.0751C18.575 15.3751 18.3333 14.7834 17.85 14.3001C17.3666 13.8168 16.775 13.5751 16.075 13.5751C15.375 13.5751 14.7833 13.8168 14.3 14.3001C13.8166 14.7834 13.575 15.3751 13.575 16.0751C13.575 16.7751 13.8166 17.3668 14.3 17.8501C14.7833 18.3334 15.375 18.5751 16.075 18.5751ZM18.1 10.4001C17.8666 10.3001 17.625 10.2208 17.375 10.1621C17.125 10.1041 16.8583 10.0668 16.575 10.0501L21.45 2.3501L22.6749 3.2501L18.1 10.4001Z",
    fill: "#0067D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestementModel);
export default __webpack_public_path__ + "static/media/investement_model.e3df2e2b878256d7e527c7acf1828565.svg";
export { ForwardRef as ReactComponent };